import type { EventType } from './events';

/**
 * Unified activity type discriminator.
 * Maps EventType values into three broad categories for routing and display.
 */
export type ActivityType = 'excursion' | 'course' | 'event';

/**
 * Normalize a producer_events.event_type value to an ActivityType.
 */
export function normalizeActivityType(eventType: EventType | string): ActivityType {
  switch (eventType) {
    case 'outing':
      return 'excursion';
    case 'course':
    case 'workshop':
      return 'course';
    case 'event':
    case 'dinner':
    default:
      return 'event';
  }
}

/**
 * Lightweight unified representation used for routing and display.
 */
export interface ActivityBase {
  id: string;
  slug?: string | null;
  title: string;
  shortDescription?: string | null;
  coverImageUrl?: string | null;
  startDate?: string | null;
  endDate?: string | null;
  producerId?: string | null;
  /** Discriminator derived via normalizeActivityType */
  activityType: ActivityType;
  /** Original event_type from DB */
  eventType?: EventType | string;
  status?: string | null;
}
